export default __webpack_public_path__ + "media/images/features/ana/yutalab-f85513ed7d34d26784fcb7454912d004.jpg";